import comTopHeader from '../../components/com-top-header.vue';
import comHeader from '../../components/com-header.vue';
import comFooter from '../../components/com-footer.vue';
import comMenu from '../../components/com-menu.vue';
export default{
    name:'Layout',
    data(){
        return{

        }
    },
    components:{
        comHeader,
        comFooter,
        comTopHeader,
        comMenu,
    },

}